function accountDetails() {
  // Code for Country/province select logic
  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify && false) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }
  
  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;
  
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
  });
  
  this.accountTabLinks = $('.js-account-tab-link');
  this.accountTabsContent = $('.js-account-tab');
  
  this.$addAddressPopup = $('#adress-add-modal');
  
  this.editAddressButton = $('.js-address-edit');
  
  this.addListenerForNavigation = function () {
    $(document).on('click', '.js-account-navigation-toggler', e => {
      $('.js-account-navigation').toggleClass('account-navigation--opened')
    })
  };
  
  this.toggleTab = function () {
    this.accountTabLinks.click((e) => {
      e.preventDefault();
      
      $('.js-account-navigation').removeClass('account-navigation--opened');
      
      let currentElement = $(e.currentTarget);
      
      this.accountTabLinks.removeClass('active');
      this.accountTabLinks.toArray().filter(x => x.getAttribute('href') == currentElement.attr('href')).forEach(x => x.classList.add('active'));

      if (window.matchMedia('(max-width: 1199px)').matches) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

      $('.js-account-navigation-toggler span').html(currentElement.html());


      
      this.accountTabsContent.hide();
      $(currentElement.attr('href')).show();
      
      
      const newLocation = location.hash ? location.href.replace(location.hash, currentElement.attr('href')) : location.href + currentElement.attr('href');
      
      history.replaceState(null, null, newLocation);
    });
    
    this.toggleActiveTab();
    window.addEventListener('hashchange', this.toggleActiveTab.bind(this));
  };
  
  this.toggleActiveTab = function () {
    if (location.hash) {
      const activeTab = this.accountTabLinks.toArray().find(x => '#' + x.href.split('#').pop() == location.hash);
      if (activeTab) $(activeTab).click();
    }
  };
  
  /*let postLink1 = function(t, e) {
      e = e || {};
      var n = e.method || "post"
          , i = e.parameters || {}
          , o = document.createElement("form");
      o.setAttribute("method", n),
          o.setAttribute("action", t);
      for (var r in i) {
          var l = document.createElement("input");
          l.setAttribute("type", "hidden"),
              l.setAttribute("name", r),
              l.setAttribute("value", i[r]),
              o.appendChild(l)
      }
      document.body.appendChild(o),
          o.submit(),
          document.body.removeChild(o)
  };*/
  
  let postLink = function (url, settings) {
    settings = settings || {};
    let method = settings.method || "post";
    let parameters = settings.parameters;
    let data = {};
    
    for (let param in parameters) {
      data[param] = parameters[param];
    }
    
    $.ajax({
      method: method,
      url: url,
      data: data,
      headers: { "cache-control": "no-cache" },
      success: function () {
        location.reload(true);
      }
    })
  };
  
  this.deleteAddress = function () {
    $('.js-address-delete').on('click', function () {
      let $el = $(this);
      let formId = $el.data('form-id');
      let confirmMessage = $el.data('confirm-message');
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
        
        // added reload page, because on Iphone X the page does't reload automatically;
        // setTimeout(function() {
        //     console.log('restart page 500');
        //     location.reload();
        // }, 500);
      }
    });
  };
  
  this.addListenerForNavigation();
  
  this.toggleTab();
  
  this.deleteAddress();
}

setTimeout(() => {
  window.scroll(0, 0);
}, 100);

accountDetails();